module.exports = __webpack_public_path__ + "img/logo_small.ceef5dea.png";